<app-ff-cabinet-head titleKey="coNav.certDeals" titleFallback="Сделки по сертификации"></app-ff-cabinet-head>

<section class="pp-card cert-empty">
  <span class="cert-empty__icon" aria-hidden="true">
    <svg viewBox="0 0 24 24"><path d="M12 3l8 3v6c0 4.5-3.4 8-8 9-4.6-1-8-4.5-8-9V6z"/><path d="M8.5 12l2.5 2.5 4.5-5"/></svg>
  </span>
  <h2>{{ t('coCert.title', 'Сделок по сертификации пока нет') }}</h2>
  <p>{{ t('coCert.text', 'Здесь будут ваши заявки на сертификаты и декларации соответствия: кто оформляет, на каком этапе, документы и оплата — как в сделках по перевозке.') }}</p>
  <p class="cert-empty__hint">{{ t('coCert.hint', 'Какие разрешительные документы нужны для товара, уже видно в расчёте — раздел «Разрешительные документы».') }}</p>
  <a class="pp-btn pp-btn--primary" routerLink="/cargo-owner/dashboard/calculations">{{ t('coCert.toCalcs', 'Открыть мои расчёты') }}</a>
</section>
